export default __webpack_public_path__ + "static/1)PuffPuffPositive-0bdfc498d11e4ebb5ced8173d48c1344.mp3";